import { Component, Input, OnInit } from '@angular/core';
import { AddressService } from '@vendasta/businesses';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { BusinessInfoCellService } from './business-info-cell.service';
import { AccountGroup } from '@galaxy/account-group';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'automata-business-cell',
  template: `
    <div class="activity-cell-primary">
      <ng-container *ngIf="{ value: (deleted$ | async) } as deleted">
        <ng-container *ngIf="deleted.value">
          <span class="deleted">{{ companyName$ | async }}</span>
        </ng-container>
        <ng-container *ngIf="!deleted.value">
          <a [routerLink]="urlLink">{{ companyName$ | async }}</a>
        </ng-container>
      </ng-container>
    </div>
    <div class="activity-cell-secondary">{{ address$ | async }}</div>
  `,
  styleUrls: ['./business-info-cell.component.scss', '../activity-cells-styles.scss'],
  imports: [CommonModule, RouterLink],
})
export class BusinessInfoCellComponent implements OnInit {
  companyName$: Observable<string>;
  address$: Observable<string>;
  deleted$: Observable<boolean>;

  urlLink = '';

  @Input() accountGroupId: string;
  @Input() accountGroup: AccountGroup;

  constructor(
    private addressService: AddressService,
    private businessInfoCellService: BusinessInfoCellService,
  ) {}

  ngOnInit(): void {
    let accountGroup$: Observable<AccountGroup>;
    if (this.accountGroupId) {
      accountGroup$ = this.businessInfoCellService.getAccountGroup(this.accountGroupId);
    } else {
      accountGroup$ = of(this.accountGroup);
      this.accountGroupId = this.accountGroup.accountGroupId;
    }

    this.urlLink = `/businesses/accounts/${this.accountGroupId}/details`;

    this.companyName$ = accountGroup$.pipe(map((accountGroup) => accountGroup.napData.companyName));

    this.address$ = accountGroup$.pipe(
      switchMap((accountGroup) =>
        this.addressService.shortAddress$({
          address1: accountGroup.napData.address,
          address2: accountGroup.napData.address2,
          city: accountGroup.napData.city,
          province: accountGroup.napData.state,
          zip: accountGroup.napData.zip,
          country: accountGroup.napData.country,
        }),
      ),
    );

    this.deleted$ = accountGroup$.pipe(
      map((accountGroup) => {
        return !!accountGroup?.deleted;
      }),
    );
  }
}
